// src/telas/cadastro-tecnico/endereco/index.tsx

import { RxDotFilled } from "react-icons/rx";
import styles from "../styles.module.css";
import { useContext, useState } from "react";
import { FormularioContext } from "..";
import cep from "cep-promise";
import Swal from "sweetalert2";
import { formatarCEP } from "../../../formatting/formatting";

export function Endereco() {
  const context = useContext(FormularioContext);

  // Campos visuais locais — não vão direto para o formulário
  const [rua, setRua]           = useState("");
  const [numero, setNumero]     = useState("");
  const [complemento, setComplemento] = useState("");

  // Monta A2_END e persiste no contexto
 function atualizarEndereco(novaRua = rua, novoNumero = numero, novoComplemento = complemento) {
  const partes = [novaRua.trim(), novoNumero.trim(), novoComplemento.trim()].filter(Boolean);
  const enderecoCompleto = partes.join(", ").toUpperCase().substring(0, 40);
  context?.setFormulario({
    ...context.formulario,
    A2_END: enderecoCompleto,
    A2_ZNUMERO: novoNumero.toUpperCase(),
  });
}

  function handleRua(e: React.ChangeEvent<HTMLInputElement>) {
    const valor = e.target.value;
    setRua(valor);
    atualizarEndereco(valor, numero, complemento);
  }

function handleNumero(e: React.ChangeEvent<HTMLInputElement>) {
  const valor = e.target.value;
  setNumero(valor);
  atualizarEndereco(rua, valor, complemento);
}

  function handleComplemento(e: React.ChangeEvent<HTMLInputElement>) {
    const valor = e.target.value;
    setComplemento(valor);
    atualizarEndereco(rua, numero, valor);
  }

  function maskCep(v: string): string {
    v = v.replace(/\D/g, "");
    v = v.replace(/(\d{8})(\d)/, "$1");
    v = v.replace(/(\d{2})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d)/, "$1-$2");
    return v;
  }

  async function buscaCep(cepStr: string) {
    cepStr = cepStr.replace(/[^\w]/g, "");
    if (cepStr.length < 8) return;

    try {
      let adress = await cep(cepStr);
      if (!adress?.city) return;

      const novaRua = adress.street?.toUpperCase() ?? "";
      setRua(novaRua);
      setNumero("");
      setComplemento("");

      context?.setFormulario({
        ...context.formulario,
        A2_MUN:    adress.city,
        A2_BAIRRO: adress.neighborhood,
        A2_EST:    adress.state,
        A2_CEP:    maskCep(cepStr),
        // A2_END começa só com a rua; usuário ainda vai digitar número/complemento
        A2_END:    novaRua.substring(0, 40),
      });
    } catch (error) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Erro ao buscar dados do CEP." + error,
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }

  function atualizarFormulario(event: React.ChangeEvent<HTMLInputElement>) {
    let nome  = event.target.name;
    let value = `${event.target.value}`.toUpperCase();

    if (nome === "A2_CEP") {
      value = formatarCEP(value);
      if (value.length > 8) buscaCep(value);
    }

    context?.setFormulario({ ...context.formulario, [nome]: value });
  }

  return (
    <div className={styles.groupCardForm}>
      {/* CEP */}
      <div className={styles.groupInput}>
        <span>
          CEP <RxDotFilled size={16} className={styles.legend} />
        </span>
        <input
          value={context?.formulario.A2_CEP}
          onChange={atualizarFormulario}
          type="text"
          name="A2_CEP"
          placeholder="00.000-000"
          maxLength={10}
        />
        <label>Digite apenas números</label>
      </div>

      {/* ENDEREÇO (rua) */}
      <div className={styles.groupInput}>
        <span>
          Endereço <RxDotFilled size={16} className={styles.legend} />
        </span>
        <input
          value={rua}
          onChange={handleRua}
          type="text"
          placeholder="Rua, avenida, travessa..."
        />
      </div>

      {/* NÚMERO + COMPLEMENTO */}
      <div className={styles.formGroup}>
        <div className={styles.groupInput}>
          <span>
            Número <RxDotFilled size={16} className={styles.legend} />
          </span>
          <input
            value={numero}
            onChange={handleNumero}
            type="text"
            placeholder="Ex: 125"
            maxLength={10}
          />
        </div>
        <div className={styles.groupInput}>
          <span>Complemento</span>
          <input
            value={complemento}
            onChange={handleComplemento}
            type="text"
            placeholder="Apto, bloco, sala..."
            maxLength={20}
          />
        </div>
      </div>

      {/* BAIRRO */}
      <div className={styles.groupInput}>
        <span>
          Bairro <RxDotFilled size={16} className={styles.legend} />
        </span>
        <input
          maxLength={20}
          value={context?.formulario.A2_BAIRRO}
          onChange={atualizarFormulario}
          type="text"
          name="A2_BAIRRO"
          placeholder="Informe o bairro"
        />
      </div>

      {/* ESTADO + MUNICÍPIO */}
      <div className={styles.formGroup}>
        <div className={styles.groupInput}>
          <span>
            Estado <RxDotFilled size={16} className={styles.legend} />
          </span>
          <input
            maxLength={20}
            value={context?.formulario.A2_EST}
            onChange={atualizarFormulario}
            type="text"
            name="A2_EST"
            placeholder="Informe o estado"
          />
        </div>
        <div className={styles.groupInput}>
          <span>
            Município <RxDotFilled size={16} className={styles.legend} />
          </span>
          <input
            maxLength={20}
            value={context?.formulario.A2_MUN}
            onChange={atualizarFormulario}
            type="text"
            name="A2_MUN"
            placeholder="Informe o município"
          />
        </div>
      </div>
    </div>
  );
}

